const config = { style: "decimal", maximumFractionDigits: 6 }
export const formatterNumber = (val) => {
    if (!val || isNaN(val)) return null;
    return Intl.NumberFormat('vi-VN', config).format(val)
}
export const parserNumber = (val) => {
    if (!val) return 0;
    return Number.parseFloat(val.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, "."))
}